import gql from 'graphql-tag';

export const GET_ADMINLOGIN = gql`
    query ($user_name: String!, $password: String!) {
        adminLogin(user_name: $user_name, password: $password){
            accessToken
        }
    },
`;

export const GET_LOGIN_ADMIN = gql`
    query {
        getLoginAdmin {
            user_id
            user_name
            login{
                golf_group_code
                golf_code
                user_div
                family_name
                user_id
            }
        }
    },
`;

export const GET_MESSAGE_COUNT = gql`
    query ($golf_group_code: String!){
        getMessageCount(golf_group_code: $golf_group_code){
            count
        }
    },
`;
